import { darken } from '@mui/material/styles'

export const modernToggleButtonGroupStyles = {
  borderRadius: '6px',
  width: '100%',
  '& .MuiToggleButton-root': {
    flexShrink: 0,
    flex: 1,
    height: '30px',
    mr: '4px',
    fontSize: '11px',
    letterSpacing: '-0.22px',
    textTransform: 'none',
    color: (theme) => theme.palette.text.secondary,
    border: (theme) => `1px solid ${theme.palette.divider} !important`,
    background: (theme) => theme.palette.background.default,
    borderRadius: '3px',
    transition:
      'color 0.2s ease-in-out, background 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    fontFamily: 'Poppins',
    '& .MuiSvgIcon-root': {
      mr: 1,
    },

    '&:hover': {
      opacity: 1,
      background: (theme) => theme.palette.background.paper,

      boxShadow: (theme) => shadows[theme.palette.mode].sm,
    },
    '&:active': {
      fontFamily: 'Poppins',
    },
    '&.Mui-selected': {
      opacity: 1,
      background: (theme) => theme.palette.background.paper,
      border: (theme) => `1px solid ${theme.palette.divider} !important`,
      boxShadow: (theme) => shadows[theme.palette.mode].sm,
      fontWeight: 600,
    },
  },
} as const

export const chipToggleButtonGroupStyles = {
  borderRadius: '6px',
  width: '100%',
  gap: 1,
  '& .MuiToggleButton-root': {
    flexShrink: 0,
    flex: 1,
    height: '24px',
    fontSize: '11px',
    letterSpacing: '-0.22px',
    textTransform: 'none',
    fontWeight: 400,
    color: (theme) => theme.palette.text.secondary,
    border: 'none',
    background: (theme) => theme.palette.background.default,
    boxShadow: 'none',
    borderRadius: '50px',
    transition:
      'color 0.2s ease-in-out, background 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    fontFamily: 'Poppins',
    '& .MuiSvgIcon-root': {
      mr: 1,
    },

    '&:hover': {
      opacity: 1,
      background: (theme) => theme.palette.background.paper,

      boxShadow: (theme) => shadows[theme.palette.mode].sm,
    },
    '&:active': {
      fontFamily: 'Poppins',
    },
    '&.Mui-selected': {
      opacity: 1,
      background: (theme) => theme.palette.background.paper,
      border: (theme) => `1px solid ${theme.palette.divider} !important`,
      fontWeight: 600,
    },
  },
} as const

export const modernTabStyles = {
  '& .MuiTabs-scroller.MuiTabs-fixed': {
    p: 1,
    m: '-8px',
    mr: '-12px',
  },
  '& .MuiTabs-root': {
    borderRadius: '4px',
    overflow: 'visible',
    minHeight: '30px',
    flexShrink: 0,
    '& .MuiTab-root': {
      background: 'transparent',
      color: (theme) => theme.palette.text.primary,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      flexGrow: 1,
      textTransform: 'none',
      fontWeight: 600,
      minHeight: 0,
      minWidth: '0px',
      height: '30px',
      fontFeatureSettings: 'liga off, clig off',
      marginRight: '4px',
      transition: 'all 0.15s ease-in-out',
      letterSpacing: '-0.15px',

      '& .MuiTypography-root': {
        fontSize: '13px',
        fontWeight: 600,
        color: (theme) => theme.palette.text.secondary,
      },
      '&.Mui-selected': {
        background: (theme) => theme.palette.top.main,
        opacity: 1,
        border: (theme) => `1px solid ${darken(theme.palette.divider, 0.05)}`,

        boxShadow: (theme) => shadows[theme.palette.mode].sm,
      },
    },
  },
} as const

export const modernButtonContainer = {
  '& .MuiButtonBase-root': {
    py: 0,
    px: '12px',
    textTransform: 'none',
    fontSize: '11px',
    minHeight: '0px',
    height: '30px',
    fontFeatureSettings: 'liga off, clig off',
    fontWeight: 500,
    flexShrink: 0,
    mx: '4px',
    border: (theme) => `1px solid ${theme.palette.divider} !important`,
    borderRadius: '3px',
    color: (theme) => theme.palette.text.secondary,
    '& .MuiButton-startIcon': {
      mr: '6px',
      color: (theme) => theme.palette.text.secondary,
    },
    boxShadow: (theme) => shadows[theme.palette?.mode]?.sm,
    '&.flat': {
      border: 'none',
      boxShadow: 'none',
    },
    '&.left': {
      ml: 0,
    },
    '&.right': {
      mr: 0,
    },
  },
}

export const modernToolbarIconButton = {
  height: '30px',
  width: '30px',
  fontSize: '11px',
  background: (theme) => theme.palette.background.paper,
  border: (theme) => `1px solid ${theme.palette.divider}`,
  borderRadius: '3px',
}

export const shadowColors = {
  dark: 'rgba(0, 0, 0, 0.1)',
  light: 'rgba(136, 161, 183, 0.1)',
}

export const shadows = {
  dark: {
    sm: `
    0 1px 2px ${shadowColors.dark},
    0 2px 4px ${shadowColors.dark}
  `,
    md: `
    0 1px 2px ${shadowColors.dark},
    0 2px 4px ${shadowColors.dark},
    0 4px 8px ${shadowColors.dark},
    0 8px 16px ${shadowColors.dark}
  `,
    lg: `
    0 1px 2px ${shadowColors.dark},
    0 2px 4px ${shadowColors.dark},
    0 4px 8px ${shadowColors.dark},
    0 8px 16px ${shadowColors.dark},
    0 16px 32px ${shadowColors.dark},
    0 32px 64px ${shadowColors.dark}
  `,
  },
  light: {
    sm: `
    0 1px 2px ${shadowColors.light},
    0 2px 4px ${shadowColors.light}
  `,
    lg: `
    0 1px 2px ${shadowColors.light},
    0 2px 4px ${shadowColors.light},
    0 4px 8px ${shadowColors.light},
    0 8px 16px ${shadowColors.light},
    0 16px 32px ${shadowColors.light},
    0 32px 64px ${shadowColors.light}
  `,
    md: `
    0 1px 2px ${shadowColors.light},
    0 2px 4px ${shadowColors.light},
    0 4px 8px ${shadowColors.light},
    0 8px 16px ${shadowColors.light}
  `,
  },
}
